<template>
  <div class="content">
    <div class="price-box">
      <span>支付金额</span>
      <span class="price">{{ price }}</span>
    </div>

    <div class="pay-type-list">
      <van-radio-group v-model="payType">
        <div class="type-item border-bottom">
          <span class="icon yticon icon-weixinzhifu"></span>
          <div class="con">
            <span class="tit">微信支付</span>
            <span>推荐使用微信支付</span>
          </div>
          <van-radio checked-color="#fa436a" name="2"></van-radio>
        </div>
        <!-- <div class="type-item b-b" @click="changePayType(2)">
				<span class="icon yticon icon-alipay"></span>
				<div class="con">
					<span class="tit">支付宝支付</span>
				</div>
				<label class="radio">
					<radio value="" color="#fa436a" :checked='payType == 2' />
					</radio>
				</label>
        </div>-->
        <div class="type-item">
          <span class="icon yticon icon-erjiye-yucunkuan"></span>
          <div class="con">
            <span class="tit">余额支付</span>
            <span
              >可用余额 ¥{{
                userInfo && userInfo.balance ? userInfo.balance : 0
              }}</span
            >
          </div>
          <van-radio checked-color="#fa436a" name="1"></van-radio>
        </div>
      </van-radio-group>
    </div>

    <span class="mix-btn" @click="confirm">确认支付</span>
    <van-overlay :show="show">
      <div class="wrapper">
        <div class="block">
          <van-icon name="cross" class="cross-icon" @click="closeIcon" />
          <div class="inner-div">
            <div class="inner-title">请输入支付密码</div>
            <div class="inner-price">金额：{{ price }}元</div>
            <!-- 密码输入框 -->
            <van-password-input
              :value="value"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 数字键盘 -->
    <van-number-keyboard v-model="value" :show="showKeyboard" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
export default {
  data() {
    return {
      payType: "2",
      orderInfo: {},
      orderNo: "",
      price: "",
      show: false,
      value: "",
      showKeyboard: false,
    };
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
  },
  created() {
    let query = this.$route.query;
    this.orderNo = query.orderNo;
    this.getPrice();
    this.getUserInfo();

    console.log(query, "query");

    if (query.payOk) {
      //支付成功

      this.$router.replace({
        path: "/pages/money/paySuccess",
        query: {
          orderNo,
        },
      });
    }
  },
  watch: {
    value(val) {
      if (val.length === 6) {
        this.checkPassword(val);
      }
    },
  },
  methods: {
    ...mapMutations(["login"]),
    getUserInfo() {
      this.$http.request(this.$http.pathMap.userInfo, "post").then((res) => {
        if (res.data) {
          this.login(res.data);
          localStorage.setItem("userId", res.data.id);
        }
      });
    },
    //选择支付方式
    changePayType(type) {
      this.payType = type;
    },
    checkPassword(value) {
      this.$http
        .request(this.$http.pathMap.checkPassword, "post", { password: value })
        .then((res) => {
          this.pwdPay();
        })
        .catch((err) => {
          this.value = "";
        });
    },
    getPrice() {
      this.$http
        .request(this.$http.pathMap.orderPrice + this.orderNo)
        .then((res) => {
          this.price = res.data;
          let that = this;
          if (that.price == 0) {
            that.$router.replace({
              path: "/pages/money/paySuccess",
              query: {
                orderNo: this.orderNo,
              },
            });
          }
        });
    },
    //确认支付
    confirm: async function () {
      let { orderNo, payType } = this;
      if (payType == 2) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", this.wxPay, false);
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", this.wxPay);
            document.attachEvent("onWeixinJSBridgeReady", this.wxPay);
          }
        } else {
          this.wxPay();
        }
      } else {
        this.moneyPay();
      }
    },
    moneyPay() {
      if (this.userInfo.isPwd === 0) {
        Dialog({
          title: "提示",
          message: "您未设置支付密码，请前往设置",
          confirmButtonText: "去设置",
        }).then(() => {
          this.$router.push("/pages/user/SetPassWord?set=1");
        });
        return;
      }
      this.show = true;
      this.showKeyboard = true;
    },
    pwdPay() {
      let { orderNo, payType } = this;
      this.$http
        .request(this.$http.pathMap.orderBalancePay, "post", {
          orderNo,
          type: payType,
        })
        .then((res) => {
          this.$router.replace({
            path: "/pages/money/paySuccess",
            query: {
              orderNo,
            },
          });
        })
        .catch((err) => {
          Dialog.confirm({
            title: "提示",
            message: err.message,
            confirmButtonText: "去充值",
          })
            .then(() => {
              this.$router.push("/pages/balanceLog/balanceLog");
            })
            .catch(() => {
              // on cancel
            });
          this.value = "";
          this.show = false;
          this.showKeyboard = false;
        });
    },
    wxPay() {
      let { orderNo, payType } = this;
      let that = this;
      that.$http
        .request(that.$http.pathMap.orderPay, "post", {
          orderNo,
          type: payType,
        })
        .then((resData) => {
          // document.getElementById("desc").innerText = "点击支付";
          wx.miniProgram.getEnv(function (res) {
            console.log(res.miniprogram, "环境"); // true
            if (res.miniprogram) {
              //跳转小程序 微信支付
              let payDataStr = encodeURIComponent(JSON.stringify(resData.data)); //因为要吧参数传递给小程序，所以这里需要转为字符串
              // 你的密钥，请务必使用一个强密钥并妥善保管
              const url = `/pages/order/myGroupBuyList?payDataStr=${payDataStr}`;
              wx.miniProgram.navigateTo({
                url: url,
              });
            } else {
              //h5微信支付
              WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                { ...resData.data },
                function (data) {
                  console.log(data, "支付");
                  if (data.err_msg == "get_brand_wcpay_request:ok") {
                    that.$router.replace({
                      path: "/pages/money/paySuccess",
                      query: {
                        orderNo,
                      },
                    });
                  } else if (data.err_msg == "get_brand_wcpay_request:cancel") {
                    this.$dialog.alert({
                      title: "提示",
                      message: "取消了支付",
                    });
                  } else {
                    this.$dialog.alert({
                      title: "提示",
                      message: "支付失败",
                    });
                  }
                }
              );
            }
          });
        });
    },
    closeIcon() {
      (this.show = false), (this.showKeyboard = false);
    },

    //获取url里携带的参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  // align-items: center;
  margin-top: 140px;
  justify-content: center;
  height: 100%;
}

.block {
  width: 270px;
  height: 270px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  .cross-icon {
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .inner-div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .inner-title {
      text-align: center;
      color: #000;
      margin-bottom: 10px;
    }
    .inner-price {
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}
.content {
  width: 100%;
}

.price-box {
  background-color: #fff;
  height: 132px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #909399;

  .price {
    font-size: 25px;
    color: #303133;
    margin-top: 6px;

    &:before {
      content: "￥";
      font-size: 20px;
    }
  }
}

.pay-type-list {
  margin-top: 10px;
  background-color: #fff;
  padding-left: 10px;
  padding-right: 10px;

  .type-item {
    height: 60px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    font-size: 15px;
    position: relative;
  }

  .icon {
    width: 50px;
    font-size: 26px;
  }

  .icon-erjiye-yucunkuan {
    color: #fe8e2e;
  }

  .icon-weixinzhifu {
    color: #36cb59;
  }

  .icon-alipay {
    color: #01aaef;
  }

  .tit {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
    margin-bottom: 2px;
  }

  .con {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: $uni-font-size-sm;
    color: $font-color-light;
  }
}

.mix-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 315px;
  height: 40px;
  margin: 40px auto 15px;
  font-size: $uni-font-size-lg;
  color: #fff;
  background-color: $base-color;
  border-radius: 5px;
}
</style>
